import React from "react";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <Link to="/">
      <div>
        <img src="/Images/CompanyLogo.svg" alt="CompanyLogo" />
      </div>
    </Link>
  );
};

export default Logo;
